import { PathOptions } from "leaflet";

export const neoenergia_pe_unreat = (feature: any): PathOptions => {
  // Unidades de Rede AT - Orange-red circles
  return {
    color: "#CC3300", // Orange-red border
    weight: 1,
    opacity: 1,
    fillColor: "#FF6633", // Light orange-red fill
    fillOpacity: 0.7,
  };
};
